import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const MODELTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ModelType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.ModelType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const MODELTYPE_CONFIG = {
  entityName: 'ModelType',
  localizationKey: 'Controlling::Entity.ModelType',
  fields: MODELTYPE_FIELDS,
  permission: 'ControllingLiquidations.ModelTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
